module.exports = __webpack_public_path__ + "img/min-logo.08fa27f7.jpg";